export default [
  {
    value: "01",
    label: "Unconditional Exemption",
  },
  {
    value: "02",
    label: "Conditional Exemption",
  },
  {
    value: "12",
    label: "Trust described in section 4947(a)(2) of the IR Code",
  },
  {
    value: "25",
    label:
      "Organization terminating its private foundation status under section 507(b)(1)(B) of the Code ",
  },
];
